<template>
  <nav id="navBar">
    <div class="logo"><img src="@/assets/tenisu.svg" alt="" /></div>
  </nav>
  <div class="background-content">
    <div class="content">
      <router-link to="/" class="back">&#60; Retour</router-link>
      <h1 class="title">
        Test Technique TrustMyContent - <span class="electric-blue">C2PA</span> 🔐 <span class="label" v-if="onSite">#sur-place</span>
        <span class="label" v-if="onSite">#{{ lang }}</span>
      </h1>
      <p>Vous trouverez ci-dessous les éléments utiles pour la réalisation du test technique.</p>
      <h2>Votre mission :</h2>
      <p v-if="onSite">
        Créer une API REST en .NET qui permet de signer une image existante avec le standard C2PA (Content Credentials). Tu as une heure pour compléter la
        tâche.
      </p>
      <p v-else>
        Créer une API REST en .NET qui permet de signer une image existante avec le standard C2PA (Content Credentials) et déployer l'application sur Azure. En
        bonus, ajouter des fonctionnalités supplémentaires qui vous semblent pertinentes.
      </p>
      <h2>Ce que l'on regarde :</h2>
      <ul>
        <li>La propreté et la lisibilité du code</li>
        <li>L'architecture applicative</li>
        <li>Le respect des fondamentaux REST</li>
        <li>La gestion des exceptions</li>
        <li>L'implémentation correcte du standard C2PA</li>
        <li v-if="!onSite">L'implémentation de tests unitaires</li>
      </ul>
      <br v-if="onSite" />
      <p v-if="onSite">
        Au vu de la courte durée du test, nous n'attendons pas de tests unitaires, mais tu devras nous expliquer, pendant l'entretien qui suit, quels tests tu
        aurais mis en place si tu avais eu plus de temps.
      </p>
      <h2 v-if="!onSite">Ce que l'on demande :</h2>
      <ul v-if="!onSite">
        <li>Créer un nouveau repo public sur GitHub/GitLab/Bitbucket/etc.</li>
        <li>Utiliser .NET pour créer l'API</li>
        <li>Créer le projet à partir de zéro</li>
        <li>Fournir un README pour savoir comment lancer et tester votre application</li>
        <li>Déployer l'application sur Azure (App Service ou Container Apps)</li>
        <li>Envoyer le lien de votre repo ET de l'application déployée au recruteur de L'Atelier</li>
      </ul>
      <h2>Spécification :</h2>
      <p>L'API doit exposer un endpoint <strong>POST /sign</strong> avec les caractéristiques suivantes :</p>
      <ul>
        <li><strong>Entrée :</strong> un fichier image (PNG ou JPEG) et des métadonnées JSON libres (ex. auteur, projet, date)</li>
        <li><strong>Sortie :</strong> l'image signée (même format) avec le manifest C2PA intégré</li>
      </ul>
      <h2>Les tâches à réaliser :</h2>
      <div class="tasks">
        <Task title="Tâche n°1" class="card-task">
          <p class="text-tasks">Créer un endpoint POST /sign qui accepte un fichier image (PNG ou JPEG) et des métadonnées JSON.</p>
        </Task>
        <Task title="Tâche n°2" class="card-task">
          <p class="text-tasks">
            Générer un manifest C2PA contenant les métadonnées JSON reçues dans la requête et une assertion précisant que l'image a été signée via votre API.
          </p>
        </Task>
        <Task title="Tâche n°3" class="card-task">
          <p class="text-tasks">Signer l'image avec le certificat de démonstration et retourner l'image signée avec le manifest intégré.</p>
        </Task>
        <Task v-if="!onSite" title="Tâche n°4" class="card-task">
          <p class="text-tasks">Déployer le projet sur Azure.</p>
        </Task>
      </div>
      <h2>Ressources utiles :</h2>
      <ul>
        <li>
          <a style="text-decoration: underline" href="https://spec.c2pa.org/specifications/specifications/2.2/specs/C2PA_Specification.html" target="_blank">
            C2PA Specification
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Task from '@/components/Task.vue';

export default {
  name: 'TMC',
  components: {
    Task,
  },
  data() {
    return {
      onSite: false,
      lang: null,
    };
  },
  mounted() {
    window.onscroll = this.onScroll;

    if (this.$route.query.onSiteLang === 'cs') {
      this.onSite = true;
      this.lang = 'csharp';
    }
  },
  methods: {
    onScroll() {
      if (window.scrollY > 50) {
        document.getElementById('navBar').classList.add('scrolled');
      } else {
        document.getElementById('navBar').classList.remove('scrolled');
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '~@/styles/variables.scss';

nav {
  height: 80px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
  padding-right: 45px;
  padding-left: 45px;
  position: fixed;
  z-index: 1;
  transition: 0.3s;
}

nav.scrolled {
  box-shadow: 0px 5px 8px rgba(variables.$electric-blue, 0.2);
  transition: 0.3s;
}

.background-content {
  background-color: #f2f7ff;
  padding-top: 120px;
  padding-bottom: 50px;
}
.back {
  text-decoration: underline;
  position: fixed;
  left: 45px;
}

.content {
  width: 930px;
  margin: 0 auto;
}

.title {
  margin-bottom: 24px;
}

span.electric-blue {
  color: variables.$electric-blue;
}

.tasks {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 24px;
}

.text-tasks {
  text-align: center;
  margin-bottom: 16px;
}

.label {
  background-color: rgba(variables.$electric-blue, 0.2);
  font-size: 14px;
  padding: 5px 8px;
  border-radius: 8px;
  margin-right: 8px;
}

@media (max-width: 1230px) {
  .back {
    position: static;
  }

  h1 {
    margin-top: 40px;
  }
}

@media (max-width: 1020px) {
  .content {
    width: 800px;
  }
}

@media (max-width: 865px) {
  .content {
    width: 700px;
  }

  .cards {
    flex-wrap: wrap;
  }

  .tasks {
    flex-wrap: wrap;
  }

  .card-task {
    width: 100%;
  }
}

@media (max-width: 760px) {
  .content {
    width: 600px;
  }
}

@media (max-width: 670px) {
  .content {
    width: 550px;
  }

  .download {
    flex-direction: column;
  }

  .card-download {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .content {
    width: 500px;
  }
}

@media (max-width: 515px) {
  .content {
    width: 400px;
  }

  h1 {
    line-height: 32px;
  }

  h2 {
    line-height: 32px;
  }
}

@media (max-width: 430px) {
  .content {
    width: 350px;
  }
}

@media (max-width: 380px) {
  .content {
    width: 300px;
  }
}
</style>
